import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults, validateParameters } from './../wayfinder'
/**
* @see \Laravel\Telescope\Http\Controllers\HomeController::telescope
* @see vendor/laravel/telescope/src/Http/Controllers/HomeController.php:15
* @route '/telescope/{view?}'
*/
export const telescope = (args?: { view?: string | number } | [view: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: telescope.url(args, options),
    method: 'get',
})

telescope.definition = {
    methods: ["get","head"],
    url: '/telescope/{view?}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Telescope\Http\Controllers\HomeController::telescope
* @see vendor/laravel/telescope/src/Http/Controllers/HomeController.php:15
* @route '/telescope/{view?}'
*/
telescope.url = (args?: { view?: string | number } | [view: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { view: args }
    }

    if (Array.isArray(args)) {
        args = {
            view: args[0],
        }
    }

    args = applyUrlDefaults(args)

    validateParameters(args, [
        "view",
    ])

    const parsedArgs = {
        view: args?.view,
    }

    return telescope.definition.url
            .replace('{view?}', parsedArgs.view?.toString() ?? '')
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \Laravel\Telescope\Http\Controllers\HomeController::telescope
* @see vendor/laravel/telescope/src/Http/Controllers/HomeController.php:15
* @route '/telescope/{view?}'
*/
telescope.get = (args?: { view?: string | number } | [view: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: telescope.url(args, options),
    method: 'get',
})

/**
* @see \Laravel\Telescope\Http\Controllers\HomeController::telescope
* @see vendor/laravel/telescope/src/Http/Controllers/HomeController.php:15
* @route '/telescope/{view?}'
*/
telescope.head = (args?: { view?: string | number } | [view: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: telescope.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:25
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:25
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:25
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:25
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::signup
* @see app/Http/Controllers/Auth/RegisteredUserController.php:23
* @route '/signup'
*/
export const signup = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: signup.url(options),
    method: 'get',
})

signup.definition = {
    methods: ["get","head"],
    url: '/signup',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::signup
* @see app/Http/Controllers/Auth/RegisteredUserController.php:23
* @route '/signup'
*/
signup.url = (options?: RouteQueryOptions) => {
    return signup.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::signup
* @see app/Http/Controllers/Auth/RegisteredUserController.php:23
* @route '/signup'
*/
signup.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: signup.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::signup
* @see app/Http/Controllers/Auth/RegisteredUserController.php:23
* @route '/signup'
*/
signup.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: signup.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\PasswordResetController::forgotPassword
* @see app/Http/Controllers/Auth/PasswordResetController.php:27
* @route '/forgot-password'
*/
export const forgotPassword = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: forgotPassword.url(options),
    method: 'get',
})

forgotPassword.definition = {
    methods: ["get","head"],
    url: '/forgot-password',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\PasswordResetController::forgotPassword
* @see app/Http/Controllers/Auth/PasswordResetController.php:27
* @route '/forgot-password'
*/
forgotPassword.url = (options?: RouteQueryOptions) => {
    return forgotPassword.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\PasswordResetController::forgotPassword
* @see app/Http/Controllers/Auth/PasswordResetController.php:27
* @route '/forgot-password'
*/
forgotPassword.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: forgotPassword.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\PasswordResetController::forgotPassword
* @see app/Http/Controllers/Auth/PasswordResetController.php:27
* @route '/forgot-password'
*/
forgotPassword.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: forgotPassword.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HomeController::home
* @see app/Http/Controllers/HomeController.php:29
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HomeController::home
* @see app/Http/Controllers/HomeController.php:29
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HomeController::home
* @see app/Http/Controllers/HomeController.php:29
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::home
* @see app/Http/Controllers/HomeController.php:29
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PagesController::howItWorks
* @see app/Http/Controllers/PagesController.php:23
* @route '/how-it-works'
*/
export const howItWorks = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: howItWorks.url(options),
    method: 'get',
})

howItWorks.definition = {
    methods: ["get","head"],
    url: '/how-it-works',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PagesController::howItWorks
* @see app/Http/Controllers/PagesController.php:23
* @route '/how-it-works'
*/
howItWorks.url = (options?: RouteQueryOptions) => {
    return howItWorks.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PagesController::howItWorks
* @see app/Http/Controllers/PagesController.php:23
* @route '/how-it-works'
*/
howItWorks.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: howItWorks.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PagesController::howItWorks
* @see app/Http/Controllers/PagesController.php:23
* @route '/how-it-works'
*/
howItWorks.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: howItWorks.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SubjectsController::subjects
* @see app/Http/Controllers/SubjectsController.php:21
* @route '/subjects'
*/
export const subjects = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: subjects.url(options),
    method: 'get',
})

subjects.definition = {
    methods: ["get","head"],
    url: '/subjects',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SubjectsController::subjects
* @see app/Http/Controllers/SubjectsController.php:21
* @route '/subjects'
*/
subjects.url = (options?: RouteQueryOptions) => {
    return subjects.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SubjectsController::subjects
* @see app/Http/Controllers/SubjectsController.php:21
* @route '/subjects'
*/
subjects.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: subjects.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SubjectsController::subjects
* @see app/Http/Controllers/SubjectsController.php:21
* @route '/subjects'
*/
subjects.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: subjects.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PagesController::parents
* @see app/Http/Controllers/PagesController.php:30
* @route '/for-parents'
*/
export const parents = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: parents.url(options),
    method: 'get',
})

parents.definition = {
    methods: ["get","head"],
    url: '/for-parents',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PagesController::parents
* @see app/Http/Controllers/PagesController.php:30
* @route '/for-parents'
*/
parents.url = (options?: RouteQueryOptions) => {
    return parents.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PagesController::parents
* @see app/Http/Controllers/PagesController.php:30
* @route '/for-parents'
*/
parents.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: parents.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PagesController::parents
* @see app/Http/Controllers/PagesController.php:30
* @route '/for-parents'
*/
parents.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: parents.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PagesController::faq
* @see app/Http/Controllers/PagesController.php:38
* @route '/faq'
*/
export const faq = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: faq.url(options),
    method: 'get',
})

faq.definition = {
    methods: ["get","head"],
    url: '/faq',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PagesController::faq
* @see app/Http/Controllers/PagesController.php:38
* @route '/faq'
*/
faq.url = (options?: RouteQueryOptions) => {
    return faq.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PagesController::faq
* @see app/Http/Controllers/PagesController.php:38
* @route '/faq'
*/
faq.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: faq.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PagesController::faq
* @see app/Http/Controllers/PagesController.php:38
* @route '/faq'
*/
faq.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: faq.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LibraryController::library
* @see app/Http/Controllers/LibraryController.php:22
* @route '/library'
*/
export const library = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: library.url(options),
    method: 'get',
})

library.definition = {
    methods: ["get","head"],
    url: '/library',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LibraryController::library
* @see app/Http/Controllers/LibraryController.php:22
* @route '/library'
*/
library.url = (options?: RouteQueryOptions) => {
    return library.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LibraryController::library
* @see app/Http/Controllers/LibraryController.php:22
* @route '/library'
*/
library.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: library.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LibraryController::library
* @see app/Http/Controllers/LibraryController.php:22
* @route '/library'
*/
library.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: library.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\TutorsController::tutors
* @see app/Http/Controllers/TutorsController.php:35
* @route '/tutors'
*/
export const tutors = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: tutors.url(options),
    method: 'get',
})

tutors.definition = {
    methods: ["get","head"],
    url: '/tutors',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TutorsController::tutors
* @see app/Http/Controllers/TutorsController.php:35
* @route '/tutors'
*/
tutors.url = (options?: RouteQueryOptions) => {
    return tutors.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TutorsController::tutors
* @see app/Http/Controllers/TutorsController.php:35
* @route '/tutors'
*/
tutors.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: tutors.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\TutorsController::tutors
* @see app/Http/Controllers/TutorsController.php:35
* @route '/tutors'
*/
tutors.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: tutors.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\BecomeTutorController::becomeATutor
* @see app/Http/Controllers/BecomeTutorController.php:40
* @route '/become-a-tutor'
*/
export const becomeATutor = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: becomeATutor.url(options),
    method: 'get',
})

becomeATutor.definition = {
    methods: ["get","head"],
    url: '/become-a-tutor',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BecomeTutorController::becomeATutor
* @see app/Http/Controllers/BecomeTutorController.php:40
* @route '/become-a-tutor'
*/
becomeATutor.url = (options?: RouteQueryOptions) => {
    return becomeATutor.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BecomeTutorController::becomeATutor
* @see app/Http/Controllers/BecomeTutorController.php:40
* @route '/become-a-tutor'
*/
becomeATutor.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: becomeATutor.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BecomeTutorController::becomeATutor
* @see app/Http/Controllers/BecomeTutorController.php:40
* @route '/become-a-tutor'
*/
becomeATutor.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: becomeATutor.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PaymentController::payment
* @see app/Http/Controllers/PaymentController.php:20
* @route '/payment'
*/
export const payment = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: payment.url(options),
    method: 'get',
})

payment.definition = {
    methods: ["get","head"],
    url: '/payment',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PaymentController::payment
* @see app/Http/Controllers/PaymentController.php:20
* @route '/payment'
*/
payment.url = (options?: RouteQueryOptions) => {
    return payment.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaymentController::payment
* @see app/Http/Controllers/PaymentController.php:20
* @route '/payment'
*/
payment.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: payment.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaymentController::payment
* @see app/Http/Controllers/PaymentController.php:20
* @route '/payment'
*/
payment.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: payment.url(options),
    method: 'head',
})

/**
* @see routes/web.php:149
* @route '/privacy-policy'
*/
export const privacyPolicy = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacyPolicy.url(options),
    method: 'get',
})

privacyPolicy.definition = {
    methods: ["get","head"],
    url: '/privacy-policy',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:149
* @route '/privacy-policy'
*/
privacyPolicy.url = (options?: RouteQueryOptions) => {
    return privacyPolicy.definition.url + queryParams(options)
}

/**
* @see routes/web.php:149
* @route '/privacy-policy'
*/
privacyPolicy.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacyPolicy.url(options),
    method: 'get',
})

/**
* @see routes/web.php:149
* @route '/privacy-policy'
*/
privacyPolicy.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: privacyPolicy.url(options),
    method: 'head',
})

/**
* @see routes/web.php:150
* @route '/terms-of-service'
*/
export const termsOfService = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: termsOfService.url(options),
    method: 'get',
})

termsOfService.definition = {
    methods: ["get","head"],
    url: '/terms-of-service',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:150
* @route '/terms-of-service'
*/
termsOfService.url = (options?: RouteQueryOptions) => {
    return termsOfService.definition.url + queryParams(options)
}

/**
* @see routes/web.php:150
* @route '/terms-of-service'
*/
termsOfService.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: termsOfService.url(options),
    method: 'get',
})

/**
* @see routes/web.php:150
* @route '/terms-of-service'
*/
termsOfService.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: termsOfService.url(options),
    method: 'head',
})

/**
* @see routes/web.php:151
* @route '/student-terms'
*/
export const studentTerms = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: studentTerms.url(options),
    method: 'get',
})

studentTerms.definition = {
    methods: ["get","head"],
    url: '/student-terms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:151
* @route '/student-terms'
*/
studentTerms.url = (options?: RouteQueryOptions) => {
    return studentTerms.definition.url + queryParams(options)
}

/**
* @see routes/web.php:151
* @route '/student-terms'
*/
studentTerms.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: studentTerms.url(options),
    method: 'get',
})

/**
* @see routes/web.php:151
* @route '/student-terms'
*/
studentTerms.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: studentTerms.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:27
* @route '/dashboard'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:27
* @route '/dashboard'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:27
* @route '/dashboard'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:27
* @route '/dashboard'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:69
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:69
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:69
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

